import { THEMES } from "./types";

let currentTheme: THEMES = 'affinicar';

// Switch from domain name
switch (window.location.hostname) {
  case 'gestion-sav.affiniwatch.com':
    currentTheme = "affiniwatch";
    break;
  case "localhost":
  case 'gestion-sav.affinicar.com':
    currentTheme = 'affinicar';
    break;
  default:
    currentTheme = 'affinicar';
    break;
}

export function useTheme() {
  return currentTheme;
}